import React from 'react';
import Icon from 'components/Icon';

const Back = ({ onClick }) => (
  <button className="btn btn_text" onClick={onClick}>
    <Icon className="icon" icon="back2" />
    <span />
  </button>
);

export default Back;
